import { ReportCardSectionPolicyNameFragment } from "../../../Utilities";
import * as CourseSectionFormat from "../CourseSection";
import * as HomeRoomSectionFormat from "../HomeRoomSection";
import * as Fields from "./fields";

export { Fields };

/**
 * Formats the full name of the given instance.
 */
export function name(instance: ReportCardSectionPolicyNameFragment) {
	let baseName = "";
	if (instance.courseSection) {
		baseName = CourseSectionFormat.name(instance.courseSection);
	} else if (instance.homeRoomSection) {
		baseName = HomeRoomSectionFormat.name(instance.homeRoomSection);
	}

	if (instance.nameSuffix) {
		return baseName + instance.nameSuffix;
	}
	return baseName;
}
